import React from 'react';

export default function JadwalKeberangkatan() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Jadwal Keberangkatan</h1>
      <p className="text-gray-500">Halaman Jadwal Keberangkatan</p>
    </div>
  );
}
